module.exports = __webpack_public_path__ + "img/leaves_D.7196d93e.png";